var dark100 = "#000";
var dark96 = "#2D2D2D";
var dark80 = "#5C5C5C";
var dark64 = "#808080";
var dark48 = "#a7a7a7";
var dark32 = "#d7d7d7";
var dark16 = "#ebebeb";
var dark8 = "#f8f8f8";
var dark4 = "#fafafa";
var white = "#FFF";
var blueDark = "#002F8D";
var blue100 = "#0446CA";
var blue48 = "#4F7DDA";
var blue24 = "#E4EDFF";
var purple100 = "#7051D4";
var purple64 = "#8765F9";
var purple24 = "#EAE3FF";
var green100 = "#0CB970";
var green64 = "#11DA94";
var green8 = "#EDFFF9";
var turquoise100 = "#97FFF2";
var yellowDark = "#EBB600";
var yellow100 = "#F8D047";
var yellow8 = "#FFF8E7";
var redDark = "#C1163F";
var red100 = "#D6204C";
var red48 = "#EE577C";
var red8 = "#FFEBF0";
var colors = {
    dark100: dark100,
    dark96: dark96,
    dark80: dark80,
    dark64: dark64,
    dark48: dark48,
    dark32: dark32,
    dark16: dark16,
    dark8: dark8,
    dark4: dark4,
    white: white,
    blueDark: blueDark,
    blue100: blue100,
    blue48: blue48,
    blue24: blue24,
    purple100: purple100,
    purple64: purple64,
    purple24: purple24,
    green100: green100,
    green64: green64,
    green8: green8,
    turquoise100: turquoise100,
    yellowDark: yellowDark,
    yellow100: yellow100,
    yellow8: yellow8,
    redDark: redDark,
    red100: red100,
    red48: red48,
    red8: red8,
};

export { blue100, blue24, blue48, blueDark, dark100, dark16, dark32, dark4, dark48, dark64, dark8, dark80, dark96, colors as default, green100, green64, green8, purple100, purple24, purple64, red100, red48, red8, redDark, turquoise100, white, yellow100, yellow8, yellowDark };
//# sourceMappingURL=design-system-colors.es5.js.map
